module.exports = __webpack_public_path__ + "media/images/icon-scroll-vertical-cc7b7562fc051e4222c9dc62452af657.svg";